module.exports = __webpack_public_path__ + "static/media/wedding.2e7a7a9e.gif";